import { CentroCusto } from 'service/api'

import { CreateSlice } from './index'

export type CostCenterState = {
    costCenterId: number
    /** Seleção múltipla; `costCenterId` segue o primeiro id para compatibilidade. */
    costCenterIds: number[]
    costCenter: CentroCusto | null
    setCostCenterId: (id: number) => void
    setCostCenterIds: (ids: number[]) => void
}

export const createCostCenterSlice: CreateSlice<CostCenterState> = set => ({
    costCenterId: -1,
    costCenterIds: [],
    costCenter: null,
    setCostCenterId: (id: number) =>
        set({ costCenterId: id, costCenterIds: id > 0 ? [id] : [] }),
    setCostCenterIds: (ids: number[]) =>
        set({ costCenterIds: ids, costCenterId: ids[0] ?? -1 }),
})
